// utils/deviceInfo.js
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export async function getDeviceFingerprint() {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    return result.visitorId;
}

export async function getDeviceInfo() {
    const getBrowser = () => {
        const ua = navigator.userAgent;
        if (ua.includes("Chrome") && !ua.includes("Edg")) return "Chrome";
        if (ua.includes("Firefox")) return "Firefox";
        if (ua.includes("Safari") && !ua.includes("Chrome")) return "Safari";
        if (ua.includes("Edg")) return "Edge";
        return "Unknown";
    };

    const getOS = () => {
        const ua = navigator.userAgent;
        if (ua.includes("Windows NT 10.0")) return "Windows 10";
        if (ua.includes("Windows NT 11.0")) return "Windows 11";
        if (ua.includes("Mac OS X")) return "MacOS";
        if (ua.includes("Linux")) return "Linux";
        if (ua.includes("Android")) return "Android";
        if (ua.includes("iPhone") || ua.includes("iPad")) return "iOS";
        return "Unknown";
    };

    const getDeviceType = () => {
        const ua = navigator.userAgent;
        if (ua.includes("Mobile")) return "Mobile";
        if (ua.includes("iPad") || ua.includes("Tablet")) return "Tablet";
        return "Laptop/Desktop";
    };

    return {
        browser: getBrowser(),
        os: getOS(),
        device_type: getDeviceType(),
        screen_resolution: `${window.screen.width}x${window.screen.height}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
}